module.exports = __webpack_public_path__ + "static/media/onlinephysiotherapy_afshin.bb25dc51.png";